import React from 'react';
import { Link } from 'react-router-dom';
import { imgUrl } from '../lib/utils';

export const GameCard = ({ product }) => {
  const linkTo = product.source === 'digiflazz'
    ? `/product/${product.slug}`
    : `/product/${product.slug}`;

  return (
    <Link
      to={linkTo}
      className="game-card group relative overflow-hidden bg-card border border-border hover:border-primary/50 rounded-xl transition-all duration-300"
      data-testid={`game-card-${product.slug}`}
    >
      {/* Image */}
      <div className="product-image relative">
        <img
          src={imgUrl(product.image)}
          alt={product.name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {/* Neon corner brackets on hover */}
        <div className="absolute top-2 left-2 w-4 h-4 border-t-2 border-l-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-2 right-2 w-4 h-4 border-b-2 border-r-2 border-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      {/* Content */}
      <div className="p-3">
        <h3 className="font-bold text-white text-sm md:text-base truncate group-hover:text-primary transition-colors font-mono">
          {product.name}
        </h3>
        {product.source === 'digiflazz' ? (
          <p className="text-xs text-primary mt-0.5 font-mono">
            {product.itemCount} item · Mulai Rp {product.startPrice?.toLocaleString('id-ID')}
          </p>
        ) : (
          <p className="text-xs text-muted-foreground capitalize mt-0.5">
            {product.category}
          </p>
        )}
      </div>

      {/* Hover neon glow overlay */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none rounded-xl">
        <div className="absolute inset-0 bg-gradient-to-t from-primary/8 via-transparent to-transparent" />
      </div>
    </Link>
  );
};

export const GameCardSkeleton = () => {
  return (
    <div className="bg-card border border-white/5 rounded-xl overflow-hidden">
      <div className="aspect-square skeleton" />
      <div className="p-3 space-y-2">
        <div className="h-4 skeleton rounded w-3/4" />
        <div className="h-3 skeleton rounded w-1/2" />
      </div>
    </div>
  );
};
